import { Link } from "react-router-dom";
import { useSEO } from "@/lib/seo";

export default function NotFound() {
    useSEO({ title: "Page Not Found", description: "We couldn’t find that page.", path: "/404" });
    return (
        <section className="min-h-[60vh] flex items-center bg-acre-bg">
            <div className="max-w-[900px] mx-auto px-6 md:px-10 lg:px-16 py-24 text-center">
                <div className="text-[11px] uppercase tracking-[0.28em] text-acre-secondary mb-5">404</div>
                <h1 className="font-serif-display text-5xl lg:text-7xl leading-[0.98] tracking-tight text-acre-secondary">
                    We couldn’t find that page.
                </h1>
                <p className="mt-6 text-acre-muted text-base lg:text-lg leading-relaxed">
                    Try heading back to the homepage, or take a look at our practice areas.
                </p>
                <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                    <Link to="/" data-testid="notfound-home" className="bg-acre-primary text-white px-7 py-4 text-sm tracking-wide hover:bg-acre-primaryHover">
                        Back to Home
                    </Link>
                    <Link to="/contact" data-testid="notfound-contact" className="border border-acre-primary text-acre-primary px-7 py-4 text-sm tracking-wide hover:bg-acre-primary hover:text-white">
                        Contact Us
                    </Link>
                </div>
            </div>
        </section>
    );
}
